<app-patient-order-table variant="inquiries" [host]="this"></app-patient-order-table>
